import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setUser } from "../../actions/userActions";
import { logOut } from "../../actions/authActions";
import { setUserLanguage } from "../../utils/services/userService";
import { appCtx } from "../../utils/hooks/appContext";
import clivetLogo from "../../image/clivet_logo.svg";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { Link as MuiLink } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const ClivetNavbar = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const user = useSelector((state) => state.user);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [, setOpen] = useState(false);
  const { modalOpen, setModalopen } = useContext(appCtx);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const anchorRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState(
    localStorage.getItem("i18nextLng")
  );

  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const navbarInternalLoggedIn = [
    { id: 1, name: t("navbarInternal.nameAccount"), href: "/account" },
    { id: 2, name: t("navbarInternal.nameDashboard"), href: "/home" },
    { id: 3, name: t("navbarInternal.mollier"), href: "/mollier_chart" },
    { id: 4, name: t("navbarInternal.nameLogout"), href: "/" },
  ];
  {
    /*const pages = [
    { id: 1, name: "ABOUT US", href: "#" },
    { id: 2, name: "BLOG", href: "#" },
    { id: 3, name: "CONTACT", href: "#" },
  ];*/
  }
  const pages = [];

  const languages = [
    { value: "en", label: "ENG", src: "https://flagcdn.com/w20/gb.png" },
    { value: "de", label: "GER", src: "https://flagcdn.com/w20/de.png" },
    { value: "sr", label: "SRB", src: "https://flagcdn.com/w20/rs.png" },
    { value: "it", label: "ITA", src: "https://flagcdn.com/w20/it.png" },
    { value: "ru", label: "RUS", src: "https://flagcdn.com/w20/ru.png" },
  ];

  const handleChangeLng = (lng) => {
    i18n.changeLanguage(lng);
    setSelectedValue(lng);
    if (isLoggedIn) {
      setUserLanguage(localStorage.getItem("jwt"), lng);
    }
  };

  const handleClose = (event) => {
    setSelectedValue(event.target.value);
    setOpen(false);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogOut = () => {
    handleCloseUserMenu();
    localStorage.removeItem("userName");
    dispatch(logOut());
  };

  useEffect(() => {
    setSelectedValue(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const name = localStorage.getItem("userName");
    dispatch(setUser(name));
  }, [dispatch]);

  return (
    <AppBar
      position="static"
      sx={{
        padding: "15px 0",
        backgroundColor: theme.palette.primary.main,
        width: "100%",
      }}
    >
      <Container maxWidth="false">
        <Toolbar disableGutters sx={{ ml: { xs: 0, md: 5 } }}>
          <Tooltip title="Back">
            <Button
              onClick={() => {
                if (location.pathname === "/") return;
                navigate(-1);
              }}
              sx={{ color: "white", p: 0, display: { xs: "none", md: "flex" } }}
            >
              <ArrowBackIosIcon />
            </Button>
          </Tooltip>

          <Box
            component={Link}
            to="/"
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              mr: 2,
            }}
          >
            {
              <Box
                component="img"
                src={clivetLogo}
                alt="Clivet"
                sx={{
                  width: "200px",
                  height: "40px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              />
            }
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              keepMounted
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.id}
                  component={MuiLink}
                  href={page.href}
                  sx={{ color: "inherit" }}
                >
                  {page.name}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <MenuItem
                key={page.id}
                component={MuiLink}
                href={page.href}
                sx={{ color: "white" }}
              >
                {page.name}
              </MenuItem>
            ))}
          </Box>

          <Box display="flex">
            <Box
              sx={{
                display: { xs: "none", md: "none", lg: "flex", xl: "flex" },
                alignItems: "center",
                mr: 2,
              }}
            >
              {isLoggedIn && (
                <Typography sx={{ fontSize: "22px" }}>{user}</Typography>
              )}
            </Box>

            <Box sx={{ flexGrow: 0, display: "flex", alignItems: "center" }}>
              {isLoggedIn && (
                <Tooltip title="Open settings">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                      sx={{
                        bgcolor: theme.palette.primary.light,
                        color: theme.palette.primary.main,
                        width: "50px",
                        height: "50px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {isLoggedIn && (
                <Menu
                  disableScrollLock
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  keepMounted
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {navbarInternalLoggedIn.map((setting) => (
                    <MenuItem
                      key={setting.id}
                      component={Link}
                      to={setting.href}
                      onClick={
                        setting.name === t("navbarInternal.nameLogout")
                          ? handleLogOut
                          : handleCloseUserMenu
                      }
                    >
                      {setting.name}
                    </MenuItem>
                  ))}
                </Menu>
              )}
              <FormControl sx={{ ml: 2, minWidth: 60 }}>
                <Select
                  onChange={handleClose}
                  sx={{
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.secondary.main,
                    border: `1px solid ${theme.palette.secondary.main}`,
                    height: "40px",
                  }}
                  value={selectedValue}
                  renderValue={(selected) => (
                    <img
                      src={languages.find((opt) => opt.value === selected)?.src}
                      alt={selected}
                    />
                  )}
                >
                  {languages.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      onClick={() => handleChangeLng(option.value)}
                    >
                      <img
                        loading="lazy"
                        width="25px"
                        src={option.src}
                        alt=""
                      />{" "}
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ClivetNavbar;
